export default __webpack_public_path__ + "media/images/carousel/19-d624c065b171dece88116f7e0bed4d05.jpg";